import { z } from "zod";

export const SHIPPING_MODES = [
  "Air Courier Air",
  "Air Heavyweight Air",
  "Ground Carrier Ground",
  "Ground FTL",
  "Ground LTL",
  "Ocean Vessel",
] as const;

export const asnCreateSchema = z.object({
  vendorId: z.number().int(),
  plantId: z.number().int(),
  invoiceNumber: z.string().min(1),
  expectedDeliveryDate: z.string(),
  shippingMode: z.enum(SHIPPING_MODES),
  trackingNumber: z.string().optional(),
  billOfLading: z.string().optional(),
  containerNumber: z.string().optional(),
  lines: z
    .array(
      z.object({
        poLineId: z.number().int(),
        shipQty: z.number().positive(),
      })
    )
    .min(1),
});
export type AsnCreateInput = z.infer<typeof asnCreateSchema>;
